import { render, staticRenderFns } from "./GoldCoverageSection.vue?vue&type=template&id=5ecfd67e&scoped=true"
import script from "./GoldCoverageSection.vue?vue&type=script&lang=js"
export * from "./GoldCoverageSection.vue?vue&type=script&lang=js"
import style0 from "./GoldCoverageSection.vue?vue&type=style&index=0&id=5ecfd67e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecfd67e",
  null
  
)

export default component.exports